module.exports = __webpack_public_path__ + "static/media/share-buyback.a8a45b9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/share-buyback.png
// module id = 1065
// module chunks = 0